/**
 * Утилита, которая делает первую букву заглавной.
 *
 * @param str строка
 */
export const capitalizeFirstLetter = (str?: string): string => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1) : '';
};
